import { WorkflowScheduleValue } from '../../workflow-schedule';

export const ACTION_TYPE = {
  apiCall: 'api_call',
  notificationAiWa: 'notification_ai_wa',
  notificationEmail: 'notification_email',
  notificationInApp: 'notification_in_app',
  notificationPush: 'notification_push',
} as const;

export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];

export const SCHEDULING_MODE = {
  deferred: 'deferred',
  immediate: 'immediate',
} as const;

export type SchedulingMode = (typeof SCHEDULING_MODE)[keyof typeof SCHEDULING_MODE];

export interface ScheduleActionReferenceMetadata {
  moduleId: string;
  isEditable: boolean;
}

export interface ScheduleActionReference {
  moduleId: string;
  contentId: string;
}

export interface ScheduleActionReferenceErrors {
  moduleId?: boolean;
  contentId?: boolean;
}

export interface ScheduleActionItemErrors {
  templateReference?: ScheduleActionReferenceErrors;
  audienceReference?: ScheduleActionReferenceErrors;
}

export interface ScheduleActionItem {
  type: ActionType;
  templateReference: ScheduleActionReference;
  audienceReference: ScheduleActionReference;
}

export type ScheduleActionSchedule = WorkflowScheduleValue & { mode: SchedulingMode };

export interface ScheduleActionValue {
  schedule: ScheduleActionSchedule;
  actions: ScheduleActionItem[];
}

export interface ScheduleActionModule {
  description?: string;
  id: string;
  moduleType?: string;
  title: string;
}

export interface ScheduleActionContent {
  id: string;
  [key: string]: unknown;
}
